<template>
  <div>
    <div
      class="parent"
      v-lazy:background-image="{
        src: headBg,
        loading: headBgLazy,
      }"
    >
      <subject-flow-widge
        subject="Python学科"
        :project="name"
        :routerLink="routerLink"
      ></subject-flow-widge>
      <div class="describe">
        <div class="divLogo">
          <img :src="logoImg" />
          <span>{{ name }}</span>
        </div>
        <div class="divDescription">{{ description }}</div>
        <pre-publish-widge
          :data="lastUpdate"
          color="rgba(21,23,42,1)"
          bgColor="rgba(225,238,255,1)"
          :links="linkData"
        ></pre-publish-widge>
        <div class="industryInfos">
          <div class="divData">
            <div class="divIndustry">
              <img :src="industryLogoUrl" alt />
              <span class="fontType">{{ type }}</span>
            </div>
          </div>
          <ul class="industryList">
            <li v-for="(item, index) in numItems" :key="index">
              <p class="fontsize">
                {{ item.num }} <em>{{ item.unit }}</em>
              </p>
              <p class="pFontSize">{{ item.type }}</p>
            </li>
          </ul>
          <div
            class="temVideo"
            @click="handleVideo(pVideoUrl)"
            v-if="pVideoUrl"
          >
            <em>
              <img src="./../../common/img/video_white.png" alt />
            </em>
            <p>项目介绍</p>
          </div>
        </div>
      </div>
      <MenuAdd ref="editMenu"></MenuAdd>
    </div>
    <div class="divDisplay"></div>
  </div>
</template>

<script>
import MenuAdd from "./../../../../components/video";
import subjectFlowWidge from "./../../../../components/subjectFlowWidge";
import prePublishWidge from './../../common/components/prePublishWidge'
export default {
  data() {
    return {
    };
  },
  components: {
    MenuAdd,
    subjectFlowWidge,
    prePublishWidge,
  },
  props: {
    logoImg: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    industryLogoUrl: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    lastUpdate: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    numItems: {
      type: Array,
      default: () => [],
    },
    //视频数量
    pVideoUrl: {
      type: String,
      default: "",
    },
    headBg: {
      type: String,
      default: require("./../img/headBg.png"),
    },
    headBgLazy: {
      type: String,
      default: require("./../img/headBg.jpg"),
    },
    linkData:{
      type:Array,
      default:()=>[]
    }
  },
  created() {},
  computed: {
    routerLink() {
      return {
        path: "/python",
      };
    },
  },
  methods: {
    handleVideo(url) {
      this.$trackEvent("视频介绍", "点击", "视频介绍");
      let obj = {
        url: url,
      };
      this.$refs.editMenu.dialogFormV(obj);
    },
    getNumObj(str) {
      let obj = {
        type: "",
        num: "",
        unit: "",
      };
      if (str) {
        let indexNum = str.indexOf("：") + 1;
        obj.type = str.slice(0, indexNum - 1);
        let indexUnit;
        let arr = str.split("");
        for (let i = indexNum; i < arr.length; i++) {
          if (isNaN(arr[i])) {
            indexUnit = i;
            break;
          }
        }
        obj.num = str.slice(indexNum, indexUnit);
        obj.unit = str.slice(indexUnit);
      }
      return obj;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/headFirstWidget.scss";
</style>
